/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  createCheckoutSession,
  getLeadOfferDetails,
} from "../redux/Slices/leadOfferSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../utils/Utils";
import Loader from "./Common/Loader";
import { useParams } from "react-router-dom";

const ConfirmationPage = () => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const { leadOfferDetailsId } = useParams();

  useEffect(() => {
    if (leadOfferDetailsId)
      dispatch(getLeadOfferDetails({ leadOfferDetailsId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, leadOfferDetailsId]);

  const { offerData, checkoutSession, loading, errorLeadOfferDetails } =
    useSelector((state) => state.leadOffer);

  const callCreateCheckoutSessionAPI = () => {
    setIsChecked(false);
    if (offerData?.leadOfferDetails?.leadOfferDetailsId) {
      const leadOfferDetailsId =
        offerData?.leadOfferDetails?.leadOfferDetailsId;
      dispatch(createCheckoutSession({ leadOfferDetailsId }));
    }
  };

  useEffect(() => {
    if (checkoutSession) {
      localStorage.setItem("checkoutSessionId", checkoutSession.id);
      localStorage.setItem("payment_LeadOfferDetailsId", leadOfferDetailsId);
      // window.open(checkoutSession?.url, "_blank");
      window.location.href = checkoutSession?.url;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutSession]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : errorLeadOfferDetails ? (
        <div className="min-vh-100 d-flex justify-content-center align-items-center px-3">
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg text-center"
            style={{ maxWidth: 420 }}
          >
            <h2 className="text-2xl font-semibold mb-2">
              {errorLeadOfferDetails}
            </h2>
            <p className="text-sm">Please try again.</p>
          </div>
        </div>
      ) : (
        <div className="formContainer min-vh-100 bg-light px-2 py-3">
          <div className="d-flex justify-content-center">
            <div
              className="clientDetailsInfoTabContainer bg-white rounded p-3 p-md-5"
              style={{
                maxWidth: "500px",
                width: "100%",
                overflowX: "hidden",
                wordBreak: "break-word",
              }}
            >
              <h3 className="fw-bold">Dear {offerData?.firstName},</h3>

              <p className="fs-5 fst-normal">
                We have agreed to start a coaching subscription of{" "}
                {offerData?.leadOfferDetails?.subscriptionDuration} months with
                a commitment of{" "}
                {offerData?.leadOfferDetails?.subscriptionDuration} months.
              </p>

              <p className="fs-5 fst-normal">
                The subscription will start shortly after you have pressed the
                button below. <br />
              </p>

              <p className="fs-5 fst-normal">
                The first payment will amount to{" "}
                <b>
                  {offerData?.leadOfferDetails?.currency}{" "}
                  {offerData?.leadOfferDetails?.firstPaymentAmount}
                </b>
                .
              </p>

              <p className="fs-5 fst-normal">
                Subsequently, you will be charged{" "}
                <b>
                  {offerData?.leadOfferDetails?.currency}{" "}
                  {offerData?.leadOfferDetails?.monthlyAmount} every month
                </b>
                .
              </p>

              <p className="fs-5 fst-normal">
                Your last payment will be on{" "}
                <b>
                  {formatDate(offerData?.leadOfferDetails?.lastPaymentDate)}
                </b>{" "}
                and will amount to
                <b>
                  {" "}
                  {offerData?.leadOfferDetails?.currency}{" "}
                  {offerData?.leadOfferDetails?.lastPaymentAmount}
                </b>
                .
              </p>

              {offerData?.oneTimePayments.length > 0 && (
                <>
                  <p className="fs-5 fst-normal">
                    One time payment details are as follows
                  </p>

                  <table className="table table-bordered table-striped mt-3">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>
                          Amount ({offerData?.leadOfferDetails?.currency})
                        </th>
                        <th>Payment Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offerData?.oneTimePayments.map((payment, index) => (
                        <tr key={payment.paymentId}>
                          <td>{index + 1}</td>
                          <td>{payment?.paymentAmount?.toFixed(2)}</td>
                          <td>{formatDate(payment.paymentDate)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              <p className="fs-5 fst-normal">
                To cancel your subscription, please email us or contact us via
                the chat function in the app.
              </p>

              <p className="fs-5 fst-normal">
                Your payment method information will be transferred <br />{" "}
                securely using SSL encryption. The data will be stored at <br />{" "}
                the third party payment provider Stripe. <br />
              </p>

              <h5 className="text-center mt-3 fw-bold">
                I look forward to getting started!
              </h5>

              {/* Checkbox Confirmation */}
              <div className="form-check mt-3">
                <input
                  className="form-check-input fs-4"
                  type="checkbox"
                  id="confirmationCheckbox"
                  onChange={(e) => setIsChecked(e.target.checked)}
                  aria-label="Confirm acceptance"
                />
                <label
                  htmlFor="confirmationCheckbox"
                  className="fst-normal ms-1"
                >
                  <p>
                    By clicking 'Get Started', you confirm the following:
                    <br />
                    1) You accept our{" "}
                    <a href="#" className="text-color text-decoration-none">
                      Coaching Information
                    </a>{" "}
                    and{" "}
                    <a href="#" className="text-decoration-none text-color">
                      Terms & Conditions
                    </a>
                    .
                    <br />
                    2) You are over 18 years of age or have parental consent.
                  </p>
                </label>
              </div>

              {/* Submit Button */}
              <button
                className="btn mt-4 w-100"
                style={{
                  backgroundColor: isChecked ? "#1769bb" : "#9ca3af",
                  color: "white",
                  borderRadius: "10px",
                  padding: "12px",
                }}
                onClick={callCreateCheckoutSessionAPI}
                disabled={!isChecked}
              >
                Get Started!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmationPage;
